import { render } from "./BorderCard.vue?vue&type=template&id=5892d5c0"
import script from "./BorderCard.vue?vue&type=script&lang=js"
export * from "./BorderCard.vue?vue&type=script&lang=js"
script.render = render

export default script